export default (function () {
    const overlay = {
        initMobile() {
            $('body').click(function (e) {
                if ($(e.target).hasClass('overlay_bg_dark')) {
                    console.log($(e.target));
                    $('.js--mob_sort').removeClass('show');
                    $('.sidebar_category').removeClass('show');
                    $('.sidebar .PM_ASBlockOutput').removeClass('show');
                    $('body').removeClass('overlay_bg_dark');
                }
            });
        },
    };
    $(document).ready(function () {
        overlay.initMobile();
    })
})()
